import { Guid } from "@/Common/Models/Guid";
import { PreventiveCareNoticeLetterTypeEnum } from "@/Common/Models/PreventiveCare/PreventiveCareNoticeLetterTypeEnum";

class PreventiveCareNotice {
    public Id: number;
    public EmployeeContactFacetId: Guid;
    public PatientContactFacetId: Guid;
    public PreventiveCareCriteriaId: Guid;
    public LetterType: PreventiveCareNoticeLetterTypeEnum;
    public GeneratedDate: Date;
    public PatientFirstName: string;
    public PatientLastName: string;
    public PatientPreferredName: string;

    public constructor(init?: Partial<PreventiveCareNotice>) {
        Object.assign(this, init);
    }
}

export { PreventiveCareNotice };
